import { useState } from "react";
import { Link } from "react-router-dom";
import { Search, History, X, ChevronDown } from "lucide-react";
import { iconFor } from "@/components/manual/icons";

export const Badge = ({ kind }) => kind ? (
  <span data-testid={`manual-badge-${kind}`} className={`ml-auto rounded-full px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${kind === "new" ? "bg-teal-100 text-teal-700" : "bg-blue-100 text-blue-700"}`}>
    {kind === "new" ? "Nuovo" : "Aggiornato"}
  </span>
) : null;

export const ManualIndex = ({ sections, activeId, q, setQ }) => {
  const [open, setOpen] = useState(false);
  const pick = () => { setQ(""); setOpen(false); };
  const groups = sections.reduce((acc, s) => ((acc[s.group] ||= []).push(s), acc), {});
  return (
    <aside className="min-w-0 lg:sticky lg:top-24 lg:self-start" data-testid="manual-index">
      <label className="relative block">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca nel manuale..." data-testid="manual-search-input"
          className="h-10 w-full rounded-lg border border-slate-200 bg-white pl-9 pr-8 text-sm outline-none transition-colors focus:border-blue-400" />
        {q && <button onClick={() => setQ("")} data-testid="manual-search-clear" className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"><X className="h-4 w-4" /></button>}
      </label>
      <button type="button" onClick={() => setOpen(!open)} data-testid="manual-index-toggle" aria-expanded={open}
        className="mt-3 flex w-full items-center justify-between rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 lg:hidden">
        Indice delle sezioni <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      <nav className={`${open ? "block" : "hidden"} mt-4 max-h-[70vh] space-y-4 overflow-y-auto pr-1 lg:block`}>
        {Object.entries(groups).map(([g, items]) => (
          <div key={g}>
            <div className="mb-1 px-2 text-[11px] font-semibold uppercase tracking-wider text-slate-400">{g}</div>
            {items.map((s) => { const Icon = iconFor(s.icon); return (
              <Link key={s.id} to={`/manuale/${s.id}`} onClick={pick} data-testid={`manual-index-${s.id}`}
                className={`flex items-center gap-2 rounded-lg px-2 py-1.5 text-sm transition-colors ${activeId === s.id && !q ? "bg-blue-50 font-medium text-blue-700" : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"}`}>
                <Icon className="h-4 w-4 shrink-0" strokeWidth={1.8} /><span className="min-w-0 truncate">{s.title}</span><Badge kind={s.badge} />
              </Link>
            ); })}
          </div>
        ))}
        <Link to="/manuale/novita" onClick={pick} data-testid="manual-index-novita"
          className={`flex items-center gap-2 rounded-lg border-t border-slate-100 px-2 py-2 text-sm ${activeId === "novita" ? "font-medium text-blue-700" : "text-slate-600 hover:text-slate-900"}`}>
          <History className="h-4 w-4" strokeWidth={1.8} />Novità e versioni
        </Link>
      </nav>
    </aside>
  );
};
